import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, TableList, Typography, TableListActions, DropdownMenuItem } from 'seagull';
import { Edit, Eye } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ContactsCell } from './ContactsCell';
const CLIENT_STATUS_BADGE_SKIN = {
    active: 'success',
    archived: 'default'
};
export const GetClientRowTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientRow(param) {
    let { client, testId, onEditClient, onViewClient } = param;
    var _client_type;
    const { t: clientsDashboardTexts } = useLocaleKeys('pages.clientsDashboard');
    const { ClientRowTestIds: TID } = useMemo(()=>GetClientRowTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(TableList.Row, {
        rowId: client.id,
        testId: TID.Root(),
        onClick: ()=>onViewClient(client),
        items: [
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    ellipsis: true,
                    weight: "normal",
                    testId: TID.Name(),
                    children: client.name
                })
            },
            {
                value: client.status ? /*#__PURE__*/ _jsx(Badge, {
                    skin: CLIENT_STATUS_BADGE_SKIN[client.status],
                    rounded: true,
                    outlined: true,
                    testId: TID.Status(),
                    children: clientsDashboardTexts.status[client.status]()
                }) : null
            },
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    weight: "light",
                    testId: TID.Type(),
                    children: clientsDashboardTexts.type[(_client_type = client.type) !== null && _client_type !== void 0 ? _client_type : 'business']()
                })
            },
            {
                value: /*#__PURE__*/ _jsx(ContactsCell, {
                    client: client,
                    testId: TID.Contacts()
                })
            }
        ],
        actionColumn: /*#__PURE__*/ _jsx(TableListActions, {
            testId: TID.Actions(),
            btnHeapId: "client-view-btn",
            buttonText: clientsDashboardTexts.actions.view(),
            buttonIcon: /*#__PURE__*/ _jsx(Eye, {
                testId: TID.ActionViewIcon()
            }),
            onClickButton: ()=>onViewClient(client),
            mobile: {
                title: client.name
            },
            children: /*#__PURE__*/ _jsx(DropdownMenuItem, {
                bi: {
                    name: 'client_edit'
                },
                iconStart: /*#__PURE__*/ _jsx(Edit, {}),
                onClick: ()=>onEditClient(client),
                testId: TID.ActionEdit(),
                children: clientsDashboardTexts.actions.edit()
            }, "edit")
        })
    });
}
